import { lazy } from 'react';

export const DocumentsPage = lazy(
  () => import('./ui/DocumentsPage/DocumentsPage'),
);
export const DocumentsDetailsPage = lazy(
  () => import('./ui/DocumentsDetailsPage/DocumentsDetailsPage'),
);
